module.exports = parcelRequire.resolve("f9MzL");